import {Injectable} from '@angular/core';
import {IResourceMethod, ResourceAction, ResourceHandler, ResourceParams} from '@ngx-resource/core';
import {ResourceAuth} from '../../common.module/auth/authenticate.resource';
import {AuthServerProvider} from '../../common.module/auth/auth-jwt.service';
import {Category} from '../../admin.categorias.module/service/category.model';

@Injectable()
@ResourceParams({
  pathPrefix: '/configuracion'
  // url: 'http://localhost:8003'
})
export class FormalitiesResource extends ResourceAuth {
  constructor(handler: ResourceHandler, authProv: AuthServerProvider) {
    super(handler, authProv);
  }

// export class FormalitiesResource extends Resource {
  // constructor(handler: ResourceHandler) {
  // super(handler);
  // }

  @ResourceAction({
    path: '/na/categorias'
  })
  obtenerUnaCategoria: IResourceMethod<any, Category[]>;

}
